const METHOD_GET = 'GET';
const METHOD_POST = 'POST';
const METHOD_PUT = 'PUT';
const METHOD_DELETE = 'DELETE';

const session = {
    project: null,
    available: [],
    permissions: [],
    integrations: {},
};

export default {
    get,
    post,
    put,
    del,
    request,
    getQueryParameter,
    session
};

function get(url) {
    return this.request(METHOD_GET, url)
}

function post(url, body) {
    return this.request(METHOD_POST, url, body)
}

function put(url, body) {
    return this.request(METHOD_PUT, url, body)
}

function del(url) {
    return this.request(METHOD_DELETE, url)
}

function requestBody(method, body) {

    let headers = {}

    if (session.project)
        headers['X-Project-Identity'] = session.project.id;

    let requestOptions;

    if (body instanceof FormData) {
        requestOptions = {
            method: method,
            headers: headers,
            body: body
        };
    } else {
        headers['Content-Type'] = 'application/json';
        requestOptions = {
            method: method,
            headers: headers,
            body: JSON.stringify(body)
        };
    }

    return requestOptions;
}


function request(method, url, body) {

    let requestOptions = requestBody(method, body);

    async function onResponse(response) {

        if (response.ok) {
            const json = await response.json();
            json.origin = response;
            return json;
        }

        if (response.status === 401) {
            location.href = process.env.VUE_APP_OAUTH_URL + "/oauth2/authorization/mosquito";
        }

        if (response.status === 400) {
            const json = await response.json();
            json.origin = response;
            return new Promise((resolve, reject) => {
                reject(json);
            });
        }
        throw Error(response);
    }

    return fetch(url, requestOptions)
        .then(onResponse)
        .catch((res) => {
            return new Promise((resolve, reject) => {
                reject(res);
            });
        });
}

function getQueryParameter(name) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return typeof params[name] !== 'undefined' ? params[name] : null;
}